import Page from 'classes/Page'

export default class BookingConfirmation extends Page {
    constructor () {
        super({
            id: 'bookingConfirmation',
            element: '.bookingConfirmation',
                elements: {
                    header: document.querySelector('.header'),

                }
        })
        if (document.getElementsByClassName(this.id).length > 0) {
            this.children02Input();
            this.removeLinkFromAccommodations();
            this.addExtraInfo();
            this.validateFields();
            this.scrollPriceInfo();
            this.openTermsAndConditions();

        }

    }

    openTermsAndConditions(){
        jQuery('.mphb-terms-and-conditions').addClass('mphb-active');
    }

    scrollPriceInfo(){

        window.addEventListener('scroll', function (event) {

            //console.log(topPos,jQuery('.bookingConfirmation').height());

            if (screen.width > 1400) {
                if((jQuery(this).scrollTop() < (jQuery('.bookingConfirmation').height() - (jQuery('.BookingReservationIMG').height() + 100)))
                && (jQuery(this).scrollTop() > 150 )){
                    //console.log("1");
                    let coupoun = jQuery(this).scrollTop();
                    let priceBreakDown = jQuery(this).scrollTop();

                    jQuery('#mphb-coupon-details').css('top', coupoun);
                    jQuery('#mphb-price-details').css('top', priceBreakDown);
                }
            }
            else if (screen.width > 1100) {
                if((jQuery(this).scrollTop() < (jQuery('.bookingConfirmation').height() - (jQuery('.BookingReservationIMG').height() + 100)))
                && (jQuery(this).scrollTop() > 50 )){
                    //console.log("2");
                    let coupoun = jQuery(this).scrollTop();
                    let priceBreakDown = jQuery(this).scrollTop();

                    jQuery('#mphb-coupon-details').css('top', coupoun);
                    jQuery('#mphb-price-details').css('top', priceBreakDown);
                }
            }


            //bookingConfirmation

            // var top_of_element = jQuery(".footer").offset().top - 150;
            // var bottom_of_element = jQuery(".footer").offset().top + jQuery(".footer").outerHeight();
            // var bottom_of_screen = jQuery(window).scrollTop() + jQuery(window).innerHeight();
            // var top_of_screen = jQuery(window).scrollTop();

            // if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
            //     // the element is visible, do something
            // } else {
            //     console.log(jQuery(this).scrollTop())
            //     let coupoun = jQuery(this).scrollTop() + 300;
            //     let priceBreakDown = jQuery(this).scrollTop() + 400;
            //     jQuery('#mphb-coupon-details').css('top', coupoun);
            //     jQuery('#mphb-price-details').css('top', priceBreakDown);
            // }


        }, true);

    }

    validateFields(){

        jQuery(function ($) {

            if(currentSiteLang == 'pt-pt'){
                var text = "Campo obrigatório";
            }
            else{
                var text = "Field required";
            }
            var i = 0;
            $( ".mphb_sc_checkout-form .mphb_sc_checkout-submit-wrapper" ).click(function() {

                $(".mphb_sc_checkout-form input[required],.mphb_sc_checkout-form select[required]").each(function(i, obj) {

                    if(!$(this).val()){
                        i++;

                        $(`<div class="requiredField `+$(this).attr('id')+`">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.9987 14.6693C11.6806 14.6693 14.6654 11.6845 14.6654 8.0026C14.6654 4.32071 11.6806 1.33594 7.9987 1.33594C4.3168 1.33594 1.33203 4.32071 1.33203 8.0026C1.33203 11.6845 4.3168 14.6693 7.9987 14.6693Z" stroke="#A3988F" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8 5.33594V8.0026" stroke="#A3988F" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8 10.6641H8.00667" stroke="#A3988F" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            `+text+`
                        </div>`).insertAfter(this);

                        if(i == 1){
                            $([document.documentElement, document.body]).animate({
                                scrollTop: ($(this).offset().top) - 200
                            }, 500);
                        }

                    }

                });

            });


            $(".mphb_sc_checkout-form input[required],.mphb_sc_checkout-form select[required]").change(function(i, obj) {
                let el = $(this).attr('id');
                $('.requiredField.'+el).remove();
            });
        });
    }

    addExtraInfo(){
        if(currentSiteLang == 'pt-pt'){
            var text = "(Taxas e Impostos incluídos)";
        }
        else{
            var text = "(Taxes included)";
        }
        jQuery('#mphb-price-details').append(`<div class="taxesIncluded">`+text+`</div>`);

        jQuery('#mphb-price-details').prepend(`<img src="`+liSiteUrl+`/assets/img/booking_reservation.jpg" class="BookingReservationIMG">`)
    }

    removeLinkFromAccommodations(){
        jQuery( ".mphb-room-type-title a" ).click(function(e){
            e.preventDefault();
        });
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    children02Input(){

        var $ = jQuery;
        var that = this;

        if(currentSiteLang == 'pt-pt'){
            var label = "Crianças dos 0 aos 2 anos*";
            var selectText = "Seleccionar";
        }
        else{
            var label = "Children From 0 to 2 years*";
            var selectText = "Select";
        }

        //select all 2-16 years to default "0"
        $(".mphb-children-chooser .mphb_checkout-guests-chooser option[value=0]").attr('selected','selected');

        $('.mphb-room-details').each(function(i, obj) {
            var index = $(this).attr('data-index');

            $($(this)).find('.mphb-children-chooser').before(`
            <p class="mphb-children-chooser02">
                <label for="mphb_room_details-`+index+`-children02">
                    `+label+`
                </label>
                <select name="mphb_room_details[`+index+`][children02]" class="childrenSelect02 mphb_room_details-`+index+`-children" data-max-allowed="1" room-index="`+index+`">
                    <option value="">— `+selectText+` —</option>
                    <option value="0" selected>0</option>
                    <option value="1">1</option>
                </select>
            </p>`);
        });


        /** 0-2 select change -> set 2-16 to 0 **/
        $( ".childrenSelect02" ).change(function(){
            var roomIndex = $(this).attr('room-index');
            if($(this).val() == 1){
                $('#mphb_room_details-'+roomIndex+'-children').val(0);
                $('#mphb_room_details-'+roomIndex+'-children').trigger('change');
                $(this).val(1);
            }
        });

        /** 2-16 select change -> set 0-2 to 0 **/
        $( ".mphb-children-chooser select" ).change(function(){
            if($(this).val() == 1){
                var selectClass = $(this).attr('id');
                $('.'+selectClass).val(0);
            }
        });
    }
}
